import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles,
} from '@material-ui/core';
import SearchBar from 'src/components/Search/SearchBar';
import HeroBackgroundImage from 'src/assets/images/home-hero-background.png';

const useStyles = makeStyles((theme) => ({
  '@keyframes backgroundScroll': {
    '0%': {
      backgroundPosition: 'center 0%',
    },
    '50%': {
      backgroundPosition: 'center 100%',
    },
    '100%': {
      backgroundPosition: 'center 0%',
    },
  },
  root: {
    backgroundColor: '#212831',
    backgroundImage: `url(${HeroBackgroundImage})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    paddingTop: '73px',
    paddingBottom: '73px',
    animation: '$backgroundScroll 30s ease-in-out infinite',
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      animationDuration: '60s',
    },
    [theme.breakpoints.up('md')]: {
      animationDuration: '90s',
    },
    [theme.breakpoints.up('lg')]: {
      animationDuration: '120s',
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: 60,
      paddingBottom: 60,
    },
  },
  technologyIcon: {
    height: 40,
    margin: theme.spacing(1),
  },
  image: {
    perspectiveOrigin: 'left center',
    transformStyle: 'preserve-3d',
    perspective: 1500,
    '& > img': {
      maxWidth: '90%',
      height: 'auto',
      transform: 'rotateY(-35deg) rotateX(15deg)',
      backfaceVisibility: 'hidden',
      boxShadow: theme.shadows[16],
    },
  },
  shape: {
    position: 'absolute',
    top: 0,
    left: 0,
    '& > img': {
      maxWidth: '90%',
      height: 'auto',
    },
  },
  logo: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      top: '16px',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: '15px',
    },
  },
  searchBar: {
    marginTop: theme.spacing(3),
  },
}));

const Hero = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              height="100%"
            >
              <Typography variant="h1" style={{ color: '#fff' }}>
                Welcome to Global Fleet Marketplace
              </Typography>
              <Box mt={2}>
                <Typography variant="h3" style={{ color: '#fff' }}>
                  Your new RFI tool in Fleet & Mobility
                </Typography>
              </Box>
              <Box mt={1} className={classes.searchBar}>
                <SearchBar />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

Hero.propTypes = {
  className: PropTypes.string,
};

export default Hero;
